import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainNavigationService } from '../main-navigation.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-tea-by-flavour',
  templateUrl: './tea-by-flavour.component.html',
  styleUrls: ['./tea-by-flavour.component.css'],
  standalone: false
})
export class TeaByFlavourComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teaFlavour: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teas: any[] = [];

  errors: string[] = [];

  headerImageURL: string | null = null;

  imageMap = {
    "sweet-honey": "honey-sweet.jpg",
    "fruity": "fruity-banner.jpg",
    "floral": "floral-banner.jpg",
    "malty-chocolate": "malty-chocolate-banner.jpg",
    "roasty": "roasty-banner.jpg",
    "nutty": "nutty-banner.jpg",
    "umami": "umami-banner.jpg",
    "mineral": "mineral-banner.jpg",
    "earthy-woody": "earthy-woody-banner.jpg", // "earthy-banner.jpg",
    "smokey": "smoky-banner.jpg",
    "spice": "spice-banner.jpg", 
    "marine-seaweed": "seaweed-banner.jpg",
    "vegetal-grassy": "grassy-banner.jpg",
    "smooth-creamy": "creamy-banner.jpg"
  };

  constructor(
    private route: ActivatedRoute,
    private mainNavigationService: MainNavigationService,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.errors = [];
      this.teaFlavour = null;
      this.teas = [];
      const flavourSlug = params['tea-flavour-slug']
      this.headerImageURL = `/assets/flavour-header/${this.imageMap[flavourSlug as keyof typeof this.imageMap]}`;
      this.mainNavigationService.getTeaFlavour(flavourSlug).subscribe({
        next: (teaFlavour) => {
          this.teaFlavour = teaFlavour;
          this.metaDataService.updateMetadata({
            title: `Teas with the ${teaFlavour.name} flavour - Sencha Tea`,
            image: `/assets/tea-type-lady/green-tea-lady.png`,
          });
        },
        error: (error) => {
          this.logger.error('An error occurred while retrieving the tea flavour:', error);
          this.errors.push('An error occurred while retrieving the tea flavour.');
        },
      });

      // Retrieve list of teas using main navigation service
      this.mainNavigationService.getTeasByFlavour(flavourSlug).subscribe({
        next: (teas) => {
          // Handle the retrieved teas
          this.teas = teas;
        },
        error: (error) => {
          // Handle the error
          this.logger.error('An error occurred while retrieving the teas:', error);
          this.errors.push('An error occurred while retrieving the teas.');
        },
      });
    });
  }  
}
